import { format } from 'date-fns'
import { v4 as uuidv4 } from 'uuid'
import Axios from 'axios'
import insertRingbaScript from '@/helpers/insertRingbaScript'

export default async function ({ app, req, query, store, $axios, $config }) {
  if (store.state.entryId) {
    console.info('Entry ID: skip')
    return
  }

  const entryId = query.entryId ?? uuidv4()
  store.commit('setEntryId', entryId)
  app.$cookies.set('entryId', entryId, {
    path: '/',
    maxAge: 60 * 60 * 24 * 7,
    sameSite: 'strict'
  })

  const debug = query.debug ?? false
  store.commit('setDebug', debug)

  console.log('=== CF header', { cfCountry: app.$cfCountry ?? null })
  const previousEntryId = app.$cookies.get('entryId')
  const countryCookie = app.$cookies.get('country')
  const ipCookie = app.$cookies.get('ip')
  const ostype = process.client ? window.navigator.userAgent : req.headers['user-agent']

  // Get A/B version
  const ab_version = $config.AB_VERSION

  console.log('=== ab_version', ab_version)
  store.commit('setOstype', ostype)  

  const payloadCountry = query.country || app.$cfCountry || countryCookie || ''

  const payloadIp = app.$cfIp || ipCookie || ''

  //   // Get IP and country from Cloudflare
  if (payloadCountry) {

    if (app.$cfCountry) {
      console.log(`Country from Cloudflare header: ${app.$cfCountry}`)
    }

    console.log('=== calculated country', payloadCountry)

    store.commit('setCountry', payloadCountry)
    store.commit('setIsIdentified', true)
  }

  if (payloadIp) {
    store.commit('setIp', payloadIp)
    store.commit('setIsGeolocated', true)
    console.log(`Set IP from Cloudflare header: ${payloadIp}`)
  }

  console.info('Getting entry ID')
  const { country, ip, city, site, deviceType, browser } = store.state
  const { deviceCategory } = store.getters

  console.log('=== payloadCountry', payloadCountry)

  const payload = {
    deeplinks: 1,
    entryid: entryId,
    results: query.results ?? 0,
    siteaddress: site.replace('v2.', '').replace('new.', '').replace('ab.', '').replace('dev-ab.', ''),
    originalentryid: previousEntryId,
    keyword: query.utm_term,
    devicecategory: deviceCategory,
    devicetype: deviceType,
    browserversion: browser.version,
    userlocaldate: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
    userlocaltime: format(new Date(), 'HH:mm:ss'),
    adid: query.msclkid || query.gclid,
    sitebrand: 'flights',
    trafficsource: query.utm_source,
    browsertype: browser.name,
    ostype: ostype,
    country: country ?? payloadCountry ?? '',
    ab_version: ab_version ?? 'A',
    ip: ip ?? payloadIp ?? '',
    urlquery: JSON.stringify(query)
  }

  // Get p parameters
  let pParameter = []
  Object.entries(query).forEach(([key, value]) => {
    if (key.startsWith('p[') && key.endsWith(']')) {
      const index = parseInt(key.replace('p[', '').replace(']', ''))
      pParameter = pParameter || []
      pParameter[index] = value
    }
  })

  // If visitor goes straight into results, force p[0]=T
  const urlPathname = window.location.pathname
  if ((urlPathname === '/hotel-results') || (urlPathname === '/car-results') || (urlPathname === '/results') || (payload.results == 1)) {
    console.log('Forcing p[0]=T')
    pParameter[0] = 'T'
  }

  if (pParameter.length) {
    payload.p = pParameter
  }

  payload.cookies = app.$cookies.getAll();

  if (query.entryId) {
    console.log(`Used Entry ID from query parameter: ${entryId}`)
  } else {
    console.log(`Autogenerated Entry ID: ${entryId}`)
  }

  const baseURL = $config.API_URL
  const axios = Axios.create()

  store.commit('setVisitorPayload', Object.fromEntries(Object.entries(payload).filter(([key, value]) => key !== 'cookies')))

  axios
    .post(baseURL + '/visitor', payload)
    .then((response) => {
      response = response.data
      console.log('Visitor response: ', response)

      if (response.deeplinks) store.commit('setDeeplinks', response.deeplinks)
      if (response.country) store.commit('setCountry', response.country)
      if (response.city) store.commit('setCity', response.city)
      if (response.query) store.commit('setIp', response.query)
      store.commit('setIsGeolocated', true)
      store.commit('setIsIdentified', true)
      store.commit('setAdsRequestParams', response);

      const siteConfig = store.state.siteConfig
      insertRingbaScript(siteConfig)
    })

  console.log(JSON.stringify(payload, true))
}
